import { z } from "zod";

export const valueType = z.enum(["percentage", "fixed"], {
  errorMap: () => ({
    message: "Value type must be either 'percentage' or 'fixed'",
  }),
});

export const languageEnum = z.enum(["en", "fr", "de", "es", "it"], {
  errorMap: () => ({
    message: "Language must be either 'fr', 'en', 'de', 'es', or 'it'",
  }),
});

export const themeModelType = z.enum(["default", "classic", "modern"], {
  errorMap: () => ({
    message: "Theme model must be either 'default', 'classic', or 'modern'",
  }),
});

export type DiscountType = z.infer<typeof valueType>;
export type ThemeModelType = z.infer<typeof themeModelType>;

export const themeType = z.object({
  model: themeModelType,
  language: languageEnum,
  primaryColor: z.string({ invalid_type_error: "Primary color must be a string" }).min(1, {
    message: "Primary color cannot be empty",
  }),
  textBeforeItems: z.string({ invalid_type_error: "Text before items must be a string" }).nullable().optional(),
  textAfterItems: z.string({ invalid_type_error: "Text after items must be a string" }).nullable().optional(),
  footer: z.string({ invalid_type_error: "Footer must be a string" }).nullable().optional(),
});
export type ThemeType = z.infer<typeof themeType>;
export type LanguageType = z.infer<typeof languageEnum>;

export const createFieldKeyStringValuesSchema = z.object(
  {
    label: z.string({ invalid_type_error: "Label must be a string" }).min(1, {
      message: "Label cannot be empty",
    }),
    value: z.string({ invalid_type_error: "Value must be a string" }).min(1, {
      message: "Value cannot be empty",
    }),
  },
  { invalid_type_error: "Field key string values must be an object" },
);

export const createFieldKeyNumberValuesSchema = z.object(
  {
    label: z.string({ invalid_type_error: "Label must be a string" }).min(1, {
      message: "Label cannot be empty",
    }),
    value: z.number({ invalid_type_error: "Value must be a number" }),
    type: valueType,
  },
  { invalid_type_error: "Field key number values must be an object" },
);

export const sendEmailSchema = z.object({
  entityType: z.enum(["invoice", "credit-note", "estimate"]),
  entityId: z.string(),
  to: z.string().email("Please enter a valid email address"),
  cc: z.string().optional().nullable(),
  bcc: z.string().optional().nullable(),
  subject: z.string().min(1, "Subject is required"),
  content: z.string().min(1, "Email content is required"),
  pdfContent: z.string().min(1, "PDF content is required"),
  documentNumber: z.string().min(1, "Document number is required"),
});
export type SendEmailSchema = z.infer<typeof sendEmailSchema>;
